(() => {
    // 同じファイルが複数回読み込まれてもイベントは一度だけ登録する。
    if (window.tuHacciHomeVisualSearchReady) return;
    window.tuHacciHomeVisualSearchReady = true;

    // スマホでも、外側のタップで入力フォーカスを外す。
    document.addEventListener('pointerdown', (event) => {
    const active = document.activeElement;
    if (!(active instanceof HTMLElement)) return;
    if (!(event.target instanceof Node)) return;

    const search = active.closest('.home-visual-search');
    if (!search || search.contains(event.target)) return;

    active.blur();
    });

    // Escapeで候補を閉じる。
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const active = document.activeElement;
    if (!(active instanceof HTMLElement)) return;
    if (!active.closest('.home-visual-search')) return;

    event.preventDefault();
    active.blur();
    });
})();
   